<template>
    <div class="container">
      <Row>
        <Col span="4" offset="1"> <Breadcrumb>
          <BreadcrumbItem >
            <router-link  :to="{ path: '/content' }">首页</router-link>
          </BreadcrumbItem>
          <BreadcrumbItem >
            <router-link  :to="{ path: '/show' }">公告</router-link>
          </BreadcrumbItem>
        </Breadcrumb>
      
        </Col>
           <Divider />
      </Row>
     <Row>
       <Col span="4" offset="2" class="cardStyle">
         <Col span="23" offset="1" class="sider"><span @click="open"  >公告</span></Col> 
       </Col>
       <Col span="17" offset="1"style="border-left: 1px solid lightgray">
         <template v-if="true==other">
             <ul style ="cursor:pointer;">
                <router-link  v-for="item in noticeList" :key="item.id"  :to="{ path: '/showdetail',query:{ detailId:item.id } }"  tag="li" 
            style="margin:0px 13px 13px 20px;text-align:left;text-overflow:ellipsis;white-space:nowrap;width:600px;font-size: 17px;">{{item.title}}</router-link>
              </ul>
              </br>
               <Page :total="total" :current="pageNum" :page-size="10"  show-sizer show-total 
 @on-change="handlePage" @on-page-size-change='handlePageSize'></Page>
            
         </template>

      <template v-if="true==other1">

        <Col span="23" offset="1"><connects></connects></Col>
      </template>
         <template v-if="true==other4">

           <Col span="23" offset="1"><Ru></Ru></Col>

         </template>
         </Col>
     </Row>
    </div>
</template>

<script>
    export default {
      name: "index",
      components:{ 
      },
      data(){
          return{
            total:null,
            pageNum:1,
            pageSize:[5,10,15,20],
            other4:false,
            other1:false,
            other:true,
            noticeList:[]
          }
      },
      mounted() {
        this.noticeSearchList();
      },
      methods:{
        noticeSearchList:function () {
          this.other=true;
          this.other4=false;
          this.other1=false;
          protocol.param_contentList.data = {};
          protocol.param_contentList.data.type="75";
          protocol.param_contentList.data.pageNum=this.pageNum;
          protocol.param_contentList.data.pageSize=10;
          this.noticeList = [];
          http.gets(protocol.param_contentList,protocol.param_contentList.data).then(response => {
             let {size,total,list} = response.data;
             if ((size > 0)) {
                this.total=total;
                for(let value of list){
                    let obj={};
                    obj.id = value.id;
                    obj.title = value.title;
                    obj.type = value.type;
                    this.noticeList.push(obj);
                }
            }else{
              this.noticeList = [];
            }
          });
        },
        handlePageSize:function(val){
          this.pageSize = val;
 
        },
        handlePage:function(val){
          this.pageNum = val;
          this.noticeSearchList();
        },
        open:function(){
            this.other1=false;
            this.other4=false;
            this.other=true;
        },
        open1:function(){
            this.other1=true;
            this.other4=false;
            this.other=false;
        },
        open4:function(){
          this.other1=false;
          this.other=false;
          this.other4=true;
        }
      }
    }
</script>

<style scoped>

 .container{
   background: #e8e8e8;
   width: 100%;  
   margin: 0 auto;  
   height: auto;  
   padding:5px;
 }
  .sider{
  
    border-bottom: 1px dashed  gray;
    height: 30px;
    line-height: 30px;
    font-family: 微软雅黑;
    font-size: 15px;
    cursor: pointer;
    text-align: left;
  }
  .cardStyle{
     background: white;
  
    box-shadow: 0.5px 0.5px 3px 0.5px darkgray;
  }

</style>



// WEBPACK FOOTER //
// src/views/show/show.vue